import React, { useEffect } from 'react';
import Imgix from 'react-imgix';
import styled from 'styled-components';
import useHover from '../../../../../hooks/useHover';
import { getImgixUrl } from '../../../../../utils/helper';

const Wrapper = styled.div`
  cursor: pointer;
  position: relative;
  border: ${({ selected }) =>
    selected ? '3px solid #a83569' : '3px solid white'};
  border-radius: 3px;
  padding: 1px;
  .selected-icon {
    top: 2px;
    right: 2px;
    position: absolute;
  }
  .fabric-image-filter {
    width: 100%;
    height: auto;
  }
`;

const initialState = {
  name: '',
  collaborator: '',
  image: '',
  description: ''
};

function FabricItem({
  image,
  name,
  setHoveredFabric,
  selected,
  onClick,
  fabric,
  isSoldOut
}) {
  const [hoverRef, isHovered] = useHover();

  useEffect(() => {
    if (isHovered) {
      setHoveredFabric(fabric);
    } else {
      setHoveredFabric(initialState);
    }
  }, [isHovered]);
  return (
    <Wrapper ref={hoverRef} onClick={onClick} selected={selected}>
      {isSoldOut ? <SoldOutBar>Sold Out</SoldOutBar> : ''}
      {selected && (
        <img
          className="selected-icon"
          src="/assets/pdp/selected-fabric.svg"
          alt="add one less to cart"
        />
      )}

      <Imgix
        imgixParams={{ auto: 'compress,format' }}
        className="fabric-image-filter"
        sizes="
        (min-width: 992px) 100px,
        30vw"
        src={getImgixUrl(image)}
        htmlAttributes={{
          alt: name,
          loading: 'lazy'
        }}
      />
    </Wrapper>
  );
}

export default FabricItem;

const SoldOutBar = styled.div`
  background: rgba(255, 255, 255, 0.85);

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  position: absolute;
  width: 100%;
  top: calc(50% - 14px);
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
